// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import Ractive from 'ractive';
import React from 'react';
import ReactDOM from 'react-dom/client';
export class ReactToRactiveAdapter extends Ractive {
    constructor() {
        super(...arguments);
        this.reactRoot = null;
    }
    onrender() {
        if (isNullOrUndefined(this.reactComponent)) {
            return;
        }
        this.initializeReactComponent();
        this.renderReactComponent();
    }
    oninit() {
        if (isNullOrUndefined(this.reactComponent)) {
            return;
        }
        this.observe('*', () => {
            this.renderReactComponent();
        });
    }
    onteardown() {
        if (this.reactRoot) {
            this.reactRoot.unmount();
        }
    }
    initializeReactComponent() {
        const container = isValidString(this.mountContainer) ? this.find(this.mountContainer) : this.el;
        if (!container) {
            // console.error('React container not found!');
            return;
        }
        const ReactComponent = this.reactComponent;
        if (!ReactComponent) {
            // console.error('No React component provided!');
            return;
        }
        this.reactRoot = ReactDOM.createRoot(container);
    }
    renderReactComponent() {
        const ReactComponent = this.reactComponent;
        if (!ReactComponent) {
            // console.error('No React component provided!');
            return;
        }
        if (!this.reactRoot) {
            return;
        }
        const props = this.get() || {};
        this.attachEventHandlers(props);
        this.reactRoot.render(React.createElement(ReactComponent, props));
    }
    attachEventHandlers(props) { }
}
Ractive.extendWith(ReactToRactiveAdapter, {
    template: '',
    mountContainer: '',
    reactComponent: null
});
